import { createSlice } from "@reduxjs/toolkit";
import locales from "../../../locales/locales";
import enMessages from "../../../locales/en.json";
import ruMessages from "../../../locales/ru.json";

const messages = {
	[locales.EN]: enMessages,
	[locales.RU]: ruMessages,
};

const initialState = {
	messages: messages,
	currentLocale: localStorage.getItem("locale") || locales.EN,
};

const localeSLice = createSlice({
	name: "locale",
	initialState,
	reducers: {
		changeLocale(state, action) {
			state.currentLocale = action.payload;
			localStorage.setItem("locale", action.payload);
		},
	},
});

export const { changeLocale } = localeSLice.actions;

export default localeSLice.reducer;
